import {
  AUSTRALIA_POST,
  CANADA_POST,
  DHL,
  FEDEX,
  FEDEX_360,
  NEWGISTICS,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  SENDLE,
  SHIPPO,
  UPS,
  USPS_SHIP,
} from '../../../common/constants/ShipperNames.js'
import {
  updateLabelConfig,
  labelConfigSelector,
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
  attachCustomsInfoSelector,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {getState, useSelector} from '../../../store.js'
import ConfigTextInput from './ConfigTextInput.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {defaultValidLabelPropertiesFunc} from './useLabelProperty.js'

export const VALID_REASON_FOR_EXPORT_SHIPPER_TYPES = [
  AUSTRALIA_POST,
  CANADA_POST,
  DHL,
  FEDEX,
  FEDEX_360,
  NEWGISTICS,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  SENDLE,
  SHIPPO,
  UPS,
  USPS_SHIP,
]

const REASON_FOR_EXPORT_DEPENDENT_PROPERTIES = [
  ...ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
]

function dependentPropertiesFunc() {
  return REASON_FOR_EXPORT_DEPENDENT_PROPERTIES
}

export function formatReasonForExportLabelProperty(shipperType) {
  return `${shipperType}__reason_for_export`
}

export function reasonForExportLabelPropertiesFunc(shipperType, labelInfoID) {
  const attachCustomsInfo = attachCustomsInfoSelector(getState(), {labelInfoID})

  return attachCustomsInfo &&
    VALID_REASON_FOR_EXPORT_SHIPPER_TYPES.includes(shipperType)
    ? [formatReasonForExportLabelProperty(shipperType)]
    : []
}

const VALID_REASON_FOR_EXPORT_LABEL_PROPERTIES =
  VALID_REASON_FOR_EXPORT_SHIPPER_TYPES.map((shipperType) =>
    formatReasonForExportLabelProperty(shipperType),
  )

export const LABEL_PROPERTY_REASON_FOR_EXPORT_EXPLANATION =
  'reason_for_export_explanation'
export const VALID_REASON_FOR_EXPORT_EXPLANATION_SHIPPER_TYPES = [
  AUSTRALIA_POST,
  CANADA_POST,
  DHL,
  FEDEX,
  FEDEX_360,
  NEWGISTICS,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  SHIPPO,
  USPS_SHIP,
]

export default function ReasonForExport() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const [propertySpecs] = ReasonForExport.propertySpecList
  const [reasonLabelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  const attachCustomsInfo = useSelector((state) =>
    attachCustomsInfoSelector(state, {labelInfoID}),
  )

  return (
    <ConfigSelect
      label="Reason For Export"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [reasonLabelProperty]: value,
        })

        onChange()
      }}
      required={CANADA_POST === shipperType}
      hide={!attachCustomsInfo}
      labelProperty={reasonLabelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="reason_for_export"
    />
  )
}

ReasonForExport.propertySpecList = [
  {
    validShipperTypes: VALID_REASON_FOR_EXPORT_SHIPPER_TYPES,
    labelPropertiesFunc: reasonForExportLabelPropertiesFunc,
    dependentPropertiesFunc,
    validLabelPropertiesFunc() {
      return VALID_REASON_FOR_EXPORT_LABEL_PROPERTIES
    },
  },
]

function reasonForExportExplanationLabelPropertiesFunc(
  shipperType,
  labelInfoID,
) {
  const [reasonLabelProperty] =
    ReasonForExport.propertySpecList[0].labelPropertiesFunc(
      shipperType,
      labelInfoID,
    )

  if (!reasonLabelProperty) {
    return []
  }

  const {[reasonLabelProperty]: reasonForExport} = labelConfigSelector(
    getState(),
    {labelInfoID},
  )

  return shipperType !== DHL && reasonForExport === 'OTHER'
    ? [LABEL_PROPERTY_REASON_FOR_EXPORT_EXPLANATION]
    : []
}

export function ReasonForExportExplanation() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const [propertySpecs] = ReasonForExportExplanation.propertySpecList
  const [explanationLabelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigTextInput
      label="Explanation"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [explanationLabelProperty]: value,
        })

        onChange()
      }}
      hide={!explanationLabelProperty}
      labelProperty={explanationLabelProperty}
      propertySpecs={propertySpecs}
    />
  )
}

ReasonForExportExplanation.propertySpecList = [
  {
    validShipperTypes: VALID_REASON_FOR_EXPORT_EXPLANATION_SHIPPER_TYPES,
    labelPropertiesFunc: reasonForExportExplanationLabelPropertiesFunc,
    dependentPropertiesFunc: (shipperType, labelInfoID) => [
      ...dependentPropertiesFunc(shipperType, labelInfoID),
      ...reasonForExportLabelPropertiesFunc(shipperType, labelInfoID),
    ],
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
